// Panel configuration (white-label support).
// Values are set via VITE_* environment variables in docker-compose.

export interface PanelConfig {
  /** API base URL (without trailing slash expected by callers that append paths). */
  apiBase: string;
  /** Telegram bot username (without @). */
  botUsername: string;
  /** Bot link (t.me/username). */
  botLink: string;
  /** Mini App URL (t.me/username/panel). */
  miniAppUrl: string;
  /** Panel title (shown in admin header / browser tab). */
  panelTitle: string;
}

const config: PanelConfig = {
  apiBase: import.meta.env.VITE_API_BASE || '/api',
  botUsername: import.meta.env.VITE_BOT_USERNAME || 'behemothpadlabot',
  botLink: import.meta.env.VITE_BOT_LINK || 'https://t.me/behemothpadlabot',
  miniAppUrl: import.meta.env.VITE_MINI_APP_URL || 'https://t.me/behemothpadlabot/panel',
  panelTitle: import.meta.env.VITE_PANEL_TITLE || 'PADLA Control Panel'
};

export default config;
